import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getTemperatureControlInformation } from 'vivino-js/api/merchants';
import { merchant } from 'vivino-js/apiPropTypes';
import { isUS } from 'vivino-js/helpers/countryHelpers';

import MerchantDetailsPresentational from './MerchantDetails.presentational';

const MerchantDetails = ({ className, countryCode, stateCode, price, merchant }) => {
  const { tos_url: tosUrl, impressum_url: impressumUrl } = merchant;

  const producerAddress = price?.producer_address;
  const importerAddress = price?.importer_address;
  // initial value to show the handler or not
  const shouldShowInfoSection =
    !!tosUrl || !!impressumUrl || !!producerAddress || !!importerAddress;

  const [timeToNextTemperatureControlShipment, setTimeToNextTemperatureControlShipment] =
    useState(null);

  const [showInfoSection, setShowInfoSection] = useState(false);
  const [showTemperatureControlToolTip, setShowTemperatureControlToolTip] = useState(false);

  function handleInfoSectionDisplay() {
    setShowInfoSection(!showInfoSection);
  }

  function handleTemperatureControlDisplay() {
    setShowTemperatureControlToolTip(!showTemperatureControlToolTip);
  }

  async function setTemperatureControlInformation() {
    if (isUS(countryCode)) {
      const temperatureControlInformation = await getTemperatureControlInformation({
        merchantId: merchant.id,
        countryCode,
        stateCode,
      });

      if (temperatureControlInformation) {
        setTimeToNextTemperatureControlShipment(temperatureControlInformation?.ships_at);
      }
    }
  }

  useEffect(() => {
    setTemperatureControlInformation();
  }, []);

  return (
    <MerchantDetailsPresentational
      merchant={merchant}
      className={className}
      timeToNextTemperatureControlShipment={timeToNextTemperatureControlShipment}
      showInfoSection={showInfoSection}
      shouldShowInfoSection={shouldShowInfoSection}
      handleInfoSectionDisplay={handleInfoSectionDisplay}
      tosUrl={tosUrl}
      impressumUrl={impressumUrl}
      producerAddress={producerAddress}
      importerAddress={importerAddress}
      handleTemperatureControlDisplay={handleTemperatureControlDisplay}
      showTemperatureControlToolTip={showTemperatureControlToolTip}
    />
  );
};

MerchantDetails.propTypes = {
  merchant: merchant.isRequired,
  stateCode: PropTypes.string,
  price: PropTypes.object,
  countryCode: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default MerchantDetails;
